import { SnackbarProps, SnackbarVariant } from 'hooks/useSnackBar';
import { Toast } from 'generated/graphql';

// Maps a server toast onto showSnackbar's arguments; the server colour drives the alert severity.
const toastToSnackbar = (toast: Pick<Toast, 'value' | 'color'>): [SnackbarProps, SnackbarVariant] => [
  { message: toast.value, color: toast.color.toLowerCase() },
  SnackbarVariant.ALERT,
];

export default toastToSnackbar;
